import React from 'react';
import searchIcon from "../../../assets/icons/search.svg";

interface SearchButtonProps {
    onClick: () => void; 
    isVisible: boolean;
}

const SearchButton: React.FC<SearchButtonProps> = ({ onClick, isVisible }) => {
    return (
        <div className="icon-button icon-search" onClick={onClick}>
            <img
                id="popup"
                src={searchIcon}
                alt="Search Button"
                className={`icon ${isVisible ? "icon-open" : ""}`}
                />            
        </div>
    );
}

export default SearchButton;